export type { TimerProps } from './Timer';
export { Timer } from './Timer';
